<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Add Package</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-card class="mt-3">
          <b-row>
            <b-col md="6" offset-md="3">
              <package-form @submit="submit"></package-form>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PackageForm from './PackageForm';

export default {
  components: {
    PackageForm
  },
  methods: {
    ...mapActions({
      createPackage: 'packages/createPackage'
    }),
    async submit(_package) {
      try {
        await this.createPackage(_package);
        this.$notify({
          type: 'success',
          text: 'Package added'
        });
        this.$router.push({ name: 'packages' });
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      }
    }
  }
};
</script>
